'use strict';

/** @type {import('.')} */
module.exports = Object;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/es-object-atoms/index.js
// module id = ../../../../es-object-atoms/index.js
// module chunks = 5